import Vue from 'vue';
import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
export default {
  // 向 API 取得貼文
  getApiPostWallData(context) {
    context.commit('UPDATE_POST_WALL_LOAD_STATUS', false);
    if (context.state.postPageIndex === 0) {
      Loading.show();
    }
    let showAmount = 5;
    let myUserAgent = navigator.userAgent;
    let mobileType = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'ios' : 'Android';
    // let tokenCheck = context.rootState.token;
    let tokenCheck = localStorage.getItem('laleToken');
    if (!tokenCheck) {
      const api = `${process.env.VUE_APP_API_PATH}/lastest/post?pageIndex=${context.state.postPageIndex}&showAmount=${showAmount}&mobileType=${mobileType}`;
      axios
        .get(api)
        .then(res => {
          context.commit('SET_POST_WALL_DATA', res.data);
          context.commit('UPDATE_POST_WALL_PAGE_INDEX');
          console.log(res.data);
          // context.commit('UPDATE_POST_WALL_LOAD_STATUS', true);
          Loading.hide();
        })
        .catch(error => {
          console.error(error);
          Loading.hide();
        });
      // .finally(() => {
      //   setTimeout(() => {
      //     Loading.hide();
      //   }, 2000);
      // });
    } else {
      const api = `${process.env.VUE_APP_API_PATH}/showTopPost?PageIndex=${context.state.postPageIndex}&ShowAmount=${showAmount}&MobileType=${mobileType}`;
      Loading.show();
      axios
        .post(api)
        .then(res => {
          context.commit('SET_POST_WALL_DATA', res.data);
          context.commit('UPDATE_POST_WALL_PAGE_INDEX');
          context.commit('UPDATE_POST_WALL_LOAD_STATUS', true);
          Loading.hide();
        })
        .catch(error => {
          console.error(error);
        });
      // .finally(() => {
      //   setTimeout(() => {
      //     Loading.hide();
      //   }, 2000);
      // });
    }
  },

  // 刪除貼文
  deleteApiPost(context, postId) {
    const api = `${process.env.VUE_APP_API_PATH}/deletePost`;
    const formData = new FormData();
    formData.append('PostId', postId);
    axios
      .post(api, formData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => {
        console.log(`刪除: ${res.data.Status}`);
        if (res.data.Status === 'success') {
          context.commit('DELETE_STATE_POST_DATA', postId);
        }
      })
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  },

  // 按讚
  clickApiLike(context, data) {
    const api = `${process.env.VUE_APP_API_PATH}/createPrsee`;
    const formData = new FormData();
    formData.append('TargetId', data.targetId); //留言 ID 或 貼文 ID
    formData.append('PostId', data.postId);
    formData.append('Flag', data.flag); //這次執行是點讚 1 還是取消讚 0
    axios
      .post(api, formData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => {})
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  },

  // 隱藏貼文
  hideApiPost(context, postId) {
    const api = `${process.env.VUE_APP_API_PATH}/hiddenPost`;
    const formData = new FormData();
    formData.append('PostId', postId);
    axios
      .post(api, formData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => {
        context.commit('HIDE_STATE_POST_DATA', postId);
        console.log(res);
      })
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  },

  // 隱藏全部貼文
  hideAllApiPost(context, friendId) {
    const api = `${process.env.VUE_APP_API_PATH}/hiddenFriend/${friendId}`;
    axios
      .post(api)
      .then(res => {
        context.commit('HIDE_STATE_ALL_POST_DATA', friendId);
        console.log(res);
      })
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  },

  // 檢舉貼文
  reportApiPost(context, params) {
    const api = `${process.env.VUE_APP_API_PATH}/report/post/add`;
    axios
      .post(api, params)
      .then(res => {
        console.log(res);
      })
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  },

  // 檢舉用戶
  reportUserApiPost(context, params) {
    const api = `${process.env.VUE_APP_API_PATH}/report/friend/add`;
    axios
      .post(api, params)
      .then(res => {
        console.log(res);
      })
      .catch(error => {
        console.error(error);
        Loading.hide();
      });
  }
};
